<div fxLayout="column" fxFlex="100" fxLayoutAlign="center center center" style="height: 100vh;">

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center center">

        <div class="container" fxLayout="column">

            <div fxLayout="row">
                <label style="font-size: 18px;">Εγγραφή χρήστη</label>
            </div>

            <div fxLayout="row" fxFlex="100">
                <mat-horizontal-stepper [linear]="true" #stepper="matHorizontalStepper" style="width: 100%;">

                    <!--#region Office 365 authentication - student-->
                    <mat-step [stepControl]="studentFormGroup">
                        <form [formGroup]="studentFormGroup">
                            <ng-template matStepLabel>
                                <label class="stepper-header">Σύνδεση</label></ng-template>

                            <div fxLayout="column">
                                <div fxLayout="row">
                                    <app-ms-office-connection (setStudentInfo)="setStudentInfo($event)"
                                                              [studentFormGroup]="studentFormGroup"></app-ms-office-connection>
                                </div>
                                <div fxFlex="100" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="5px">
                                    <button style="color: red" mat-raised-button (click)="cancelRegistrationPrompt()">Ακύρωση</button>
                                    <button [ngClass]="{'activeButton': !isButtonDisabled(), 'disabledButton': isButtonDisabled()}"
                                            mat-raised-button matStepperNext>Επόμενο
                                    </button>
                                </div>
                            </div>


                        </form>
                    </mat-step>
                    <!--#endregion-->

                    <!--#region parent initialization form-->
                    <mat-step [stepControl]="parentFormGroup">
                        <form [formGroup]="parentFormGroup">
                            <ng-template matStepLabel>
                                <label class="stepper-header">Στοιχεία χρήστη</label></ng-template>
                            <div fxLayout="column" fxFlex="100">
                                <div fxFlex="100" fxLayout="row">
                                    <app-initialize-parent
                                            [parentFormGroup]="parentFormGroup"></app-initialize-parent>
                                </div>
                                <div fxFlex="100" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="5px">
                                    <button style="color: red" mat-raised-button (click)="cancelRegistrationPrompt()">Ακύρωση</button>
                                    <button mat-button matStepperPrevious>Προηγούμενο</button>
                                    <button [ngClass]="{'activeButton': !isParentButtonDisabled(), 'disabledButton': isParentButtonDisabled()}"
                                            mat-button matStepperNext>Επόμενο
                                    </button>
                                </div>
                            </div>
                        </form>
                    </mat-step>
                    <!--#endregion-->
                    <!--#region complete parent registration-->
                    <mat-step>
                        <ng-template matStepLabel>
                            <label class="stepper-header">Ολοκλήρωση</label></ng-template>

                        <div fxLayout="column">

                            <!--#region Parent Info -->
                            <div fxLayout="row">
                                <h3>Τα στοιχεία σας ως χρήστης</h3>
                            </div>

                            <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-evenly" fxLayoutGap="5px"
                                 class="wizard-row">

                                <mat-form-field appearance="legacy" fxFlex="48">
                                    <mat-label class="stepper-header">Όνομα</mat-label>
                                    <input matInput [value]="parentFormGroup.controls.first_name.value" tabindex="1"
                                           readonly disabled>
                                </mat-form-field>

                                <mat-form-field appearance="legacy" fxFlex="48">
                                    <mat-label class="stepper-header">Επώνυμο</mat-label>
                                    <input matInput [value]="parentFormGroup.controls.last_name.value" tabindex="2"
                                           readonly disabled>
                                </mat-form-field>

                                <mat-form-field appearance="legacy" fxFlex="48">
                                    <mat-label class="stepper-header">Τηλέφωνο</mat-label>
                                    <input matInput [value]="parentFormGroup.controls.telephone.value" tabindex="3"
                                           readonly disabled>
                                </mat-form-field>

                                <mat-form-field appearance="legacy" fxFlex="48">
                                    <mat-label class="stepper-header">Email</mat-label>
                                    <input matInput [value]="parentFormGroup.controls.email.value" tabindex="4" readonly
                                           disabled>
                                </mat-form-field>

                                <mat-form-field appearance="legacy" fxFlex="48">
                                    <mat-label class="stepper-header">Πατέρας / Μητέρα</mat-label>
                                    <input matInput
                                           [value]="+parentFormGroup.controls.parentType.value === 1 ? 'Πατέρας' : 'Μητέρα'"
                                           tabindex="4" readonly disabled>

                                </mat-form-field>
                            </div>
                            <!--#endregion-->

                            <!--#region Student Info-->
                            <div fxLayout="row">
                                <h3>Επιπλέον στοιχεία</h3>
                            </div>

                            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" fxLayoutGap="5px"
                                 class="wizard-row">

                                <mat-form-field appearance="legacy">
                                    <mat-label class="stepper-header">Όνομα</mat-label>
                                    <input matInput [value]="student?.firstName" readonly disabled>
                                </mat-form-field>

                                <mat-form-field appearance="legacy">
                                    <mat-label class="stepper-header">Επώνυμο</mat-label>
                                    <input matInput [value]="student?.lastName" readonly disabled>
                                </mat-form-field>

                                <mat-form-field appearance="legacy">
                                    <mat-label class="stepper-header">Ημ. Γέννησης</mat-label>
                                    <input matInput [value]="student?.birthday" readonly disabled>
                                </mat-form-field>

                                <mat-form-field appearance="legacy">
                                    <mat-label class="stepper-header">Email</mat-label>
                                    <input matInput [value]="student?.email" readonly disabled>
                                </mat-form-field>

                            </div>
                            <!--#endregion-->

                            <div fxLayout="row" fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="5px">
                                <button style="color: red" mat-raised-button (click)="cancelRegistrationPrompt()">Ακύρωση</button>
                                <button mat-button matStepperPrevious>Προηγούμενο</button>
                                <button mat-raised-button color="primary" (click)="promptRegistration()">Ολοκλήρωση
                                </button>
                            </div>
                        </div>
                    </mat-step>
                    <!--#endregion-->
                </mat-horizontal-stepper>

            </div>
        </div>

    </div>

</div>
